import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.connection-test';
import * as api from '../../../clients/einlasskontrolle';

@Injectable()
export class EinlasskontrolleConnectionTestEffects {

    ConnectionTest$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_CONNECTION_TEST),
        mergeMap((x: ac.GetConnectionTestAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getConnectionTest().pipe(
                map((result: any) => {
                    return new ac.GetConnectionTestErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetConnectionTestFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.EinlasskontrolleSqlService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.EinlasskontrolleSqlService {
        if (this.service === null) {
            this.service = this.injector.get(api.EinlasskontrolleSqlService);
        }
        return this.service;
    }
}
